import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface alertsIF{
    bedState:number,
    bedStateAlertLevel:string,
    bed_id:string,
    resident_id:string,
    resolved:string,
    resolved_user_id:string,
    timestamp:string,
}
interface IFHisSlice{
    alerts:alertsIF[],
    breath:{},
    sleepQuality:{},
    autoRoll:{},
    autoBed:{},
    timestamp:"",
    timestampBegin:"",
    timestampEnd:'',
    reset:[]
}
const initialState:IFHisSlice = {
    alerts:[],
    breath:{},
    sleepQuality:{},
    autoRoll:{},
    autoBed:{},
    timestamp:"",
    timestampBegin:"",
    timestampEnd:'',
    reset:[]
}
export const HistoryDataSlice = createSlice({
    name:"HistoryData",
    initialState,
    reducers:{
        ADD_HIS_ALERTS:(state, action:PayloadAction<alertsIF[]>)=>{
            if(action.payload!==null){
                let a = action.payload.filter(res=>{return res.bedState!==208})
                state.alerts=a
            }
        },
        ADD_HIS_BREATHS:(state, action)=>{
            if(action.payload!==null){ state.breath=action.payload }
        },
        ADD_HIS_SQ:(state, action)=>{
            if(action.payload!==null){ state.sleepQuality=action.payload }
        },
        ADD_HIS_AUTOROLL:(state, action)=>{
            if(action.payload!==null){ state.autoRoll=action.payload }
        },
        ADD_HIS_AUTOBED:(state, action)=>{
            if(action.payload!==null){ state.autoBed=action.payload }
        },
        ADD_HIS_DATE:(state, action)=>{
            if(action.payload!==null){ state.timestamp=action.payload }
        },
        ADD_TIME_START:(state, action)=>{
            if(action.payload!==null){ state.timestampBegin=action.payload }
        },
        ADD_TIME_END:(state, action)=>{
            if(action.payload!==null){ state.timestampEnd=action.payload }
        },
        ADD_HIS_RESET:(state, action)=>{
            if(action.payload!==null){ state.reset=action.payload }
        }
    },

})

export const {
    ADD_HIS_DATE,
    ADD_HIS_ALERTS,
    ADD_HIS_BREATHS,
    ADD_HIS_SQ,
    ADD_HIS_AUTOBED,
    ADD_TIME_START,
    ADD_TIME_END,
    ADD_HIS_AUTOROLL
} = HistoryDataSlice.actions

export default HistoryDataSlice.reducer